module.exports = __WEBPACK_EXTERNAL_MODULE_14__;


//////////////////
// WEBPACK FOOTER
// external "esri/widgets/support/widget"
// module id = 14
// module chunks = 0